<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';
	//Stores
	import { rebooting_devices } from 'src/stores/device-runtime/process';
	//Components
	import ModalPrompt from '../../../ModalPrompt.svelte';
	//Design system components
	import { Button, Text, toast } from '@Shelly/shelly-design-system';

	export let device;
	const id = real_id(device.id);

	let showModal = false;
	let loading = false;

	const rebootDevice = async () => {
		loading = true;

		const res = await gen2Request(device, 'Sys.RestartApplication', {});

		if (res.isok) {
			toast.open({ type: 'success', title: $format('soft_reboot_scc_toast') });
			rebooting_devices.update(id);
		} else {
			toast.open({ type: 'danger', title: $format('reboot_err_toast') });
		}
		loading = false;
	};

	let props = {
		title: capFirstChar(
			`${$format('modal_title_soft_reboot', {
				default: 'Soft Reboot',
			})} ${$format('process_device')}?`,
		),
		text: $format('soft_reboot_device_confirmation_msg', {
			default:
				'A soft reboot will restart the device’s operating system, which can help resolve minor issues and improve performance.',
		}),
		button_2: $format('button_cancel'),
		button_1: $format('button_soft_reboot'),
		callback: rebootDevice,
	};
</script>

<Text styleType="body-small" class="mb-s">{$format('soft_reboot_description')}</Text>

<Button {loading} size="m" width="full" on:click={() => (showModal = true)}
	>{capFirstChar($format('button_soft_reboot'))}</Button
>

<!-- Check spacings after texts -->
{#if showModal}
	<ModalPrompt bind:showModal {props} />
{/if}
